
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import ImageSelector from '@/components/ImageSelector.vue';
  import DatePicker from '@/components/date-picker.vue';
  import TimePicker from '@/components/TimePicker.vue';

  @Component({
    components: {TimePicker, DatePicker, ImageSelector},
  })
  export default class DlgTrainingNew extends Vue {
    public $refs!: {
      form: any,
    };

    @Action('admin/trainings/create') private createTraining!: any;
    @Action('admin/trainings/read') private readTrainings!: any;
    @Action('admin/companies/read') private readCompanies!: () => Promise<any>;

    @Getter('common/rules/all') private rules!: any;
    @Getter('admin/companies/all') private companies!: any;

    private training: any = {};
    private dialog: boolean = false;
    private loading: boolean = false;
    private valid: boolean = true;
    private deadlineDate: string = '';
    private deadlineTime: string = '';
    private date: string = '';
    private time: string = '';

    private async save() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        const deadlineDate = this.deadlineDate.split('.').map((e: string) => parseInt(e, 10));
        const deadlineTime = this.deadlineTime.split(':').map((e: string) => parseInt(e, 10));
        this.training.deadline =
          new Date(deadlineDate[2], deadlineDate[1] - 1, deadlineDate[0], deadlineTime[0], deadlineTime[1]);

        const trainingDate = this.date.split('.').map((e: string) => parseInt(e, 10));
        const trainingTime = this.time.split(':').map((e: string) => parseInt(e, 10));
        this.training.date =
          new Date(trainingDate[2], trainingDate[1] - 1, trainingDate[0], trainingTime[0], trainingTime[1]);

        await this.createTraining(this.training);
        await this.readTrainings();
        this.dialog = false;
        this.training = {};
        this.loading = false;
      }
    }

    private async created() {
      this.loading = true;
      if (this.companies.length === 0) {
        await this.readCompanies();
      }
      this.loading = false;
    }
  }
